const guidedFlowFeatures = {
    customFlowSystemId: undefined,
    isAiAssistGuidedFlowEnabled: false,
    isDeviceActivationGuideIntentAutoOpenEnabled: false,
    isGuidedFlowRecommendationEnabled: false,
    isSolveGuidedFlowsEnabled: false,
};

const workspaceCustomerFeatures = {
    isAutoSummaryEnabled: false,
    isPreviousSessionSummaryEnabled: false,
};

const workspaceSalesFeatures = {
    isRapportEnabled: false,
    isChecklistSummaryEnabled: false,
    isChallengeEnabled: false,
    isGaiaCallResolutionEnabled: false,
    isUsingMovedDiscoveryAndEngagementQuestions: false,
    isGuidedBrowsingEnabled: false,
    isLongFormAiEnabled: false,
    isAudioDisclosuresEnabled: false,
    isStringExamplesListEnabled: false,
    isClaimDetailsEnabled: false,
};

const workspaceExpertFeatures = {
    includesSendToPartnerMeta: false,
    isProactiveEnabled: false,
    isVerizonCareEnabled: false,
    isLightModeEnabled: false,
    isGaiaMultiStepSummaryEnabled: false,
    isChatIssueSummaryEnabled: false,
    isMicroLearningV2Enabled: false,
    logoutPendingDuration: 3000,
    isTrainingFeedbackEnabled: false,
    isUpdatedEndSessionFlowEnabled: false,
    sendSummaryFromBackend: false,
    isPacingEnabled: false,
    isGlowBarPacingEnabled: false,
    useMdnForAccountNo: false,
    isUpdatedCustomerHandoffEnabled: false,
    isVoiceWorkspaceRedesignV2Enabled: false,
    isExpertHubScheduleEnabled: false,
    isExpertHubAutoAvailableEnabled: false,
    dynamicCallbackSessionSummaryEnabled: false,
    dynamicCallbackCallbarEnabled: false,
};

/**
 * Maps clean feature flag names (used in code) to actual flag names (used in API)
 * This allows us to use clean names like `IsChecklistSummaryEnabled` in code
 * while fetching the actual flag name like `Sales-IsChecklistSummaryEnabled`
 */
export const FLAG_NAME_MAP: Record<string, string> = {
    isChallengeEnabled: "Sales-isChallengeEnabled",
    isMicroLearningV2Enabled: "EWP-isMicroLearningV2Enabled",
    logoutPendingDuration: "EWP-logoutPendingDuration",
    isChecklistSummaryEnabled: "Sales-IsChecklistSummaryEnabled",
    isRapportEnabled: "Sales-isRapportEnabled",
    isUsingMovedDiscoveryAndEngagementQuestions: "Sales-isUsingMovedDiscoveryAndEngagementQuestions",
    isGuidedBrowsingEnabled: "Sales-isGuidedBrowsingEnabled",
    isLongFormAiEnabled: "Sales-isLongFormAiEnabled",
    isAudioDisclosuresEnabled: "Sales-isAudioDisclosuresEnabled",
    isVoiceWorkspaceRedesignV2Enabled: "EWP-isVoiceWorkspaceRedesignV2Enabled",
    isStringExamplesListEnabled: "Sales-isStringExamplesListEnabled",
    dynamicCallbackSessionSummaryEnabled: "EWP-dynamicCallbackSessionSummaryEnabled",
    dynamicCallbackCallbarEnabled: "EWP-dynamicCallbackCallbarEnabled",
};

export const workspaceFeatures = {
    ...guidedFlowFeatures,
    ...workspaceCustomerFeatures,
    ...workspaceExpertFeatures,
    ...workspaceSalesFeatures,
};
